import React from 'react'
import { Navbar, Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './css/navbar.css'

function navbar () {
  /* function scroll () {
    if (window.location.pathname.includes('/s') || window.location.pathname.includes('/p') || window.location.pathname.includes('/a') || window.location.pathname.includes('/c')) {
      window.location = '/'
    } else {
      console.log(window.location.pathname)
      var elmntToView = document.getElementById('intro')
      elmntToView.scrollIntoView()
    }
  } */

  return (
    <>
      <Navbar id='nav-logo' sticky='top' collapseOnSelect expand='lg' bg='light' variant='light'>
        <Navbar.Brand><Link to='/'>Abhinav</Link></Navbar.Brand>
        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='ml-auto'>
            <Nav.Link><Link to='/skills'>Skills</Link></Nav.Link>
            <Nav.Link><Link to='/projects'>Projects</Link></Nav.Link>
            <Nav.Link><Link to='/achievements'>Achievements</Link></Nav.Link>
            <Nav.Link><Link to='/positions_of_responsibilities'>Responsibilities</Link></Nav.Link>
            <Nav.Link><Link to='/connectwith_abhinav'>Connect with me?</Link></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  )
}

export default navbar
